export default __webpack_public_path__ + "static/media/glo.0d329cb6.svg";